export default {
  downtimeUrl: "https://id.kodland.tech",
  startPage: {
    image: "/welcome/quiz_coding.jpeg",
    title: "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    subtitle:
      "Dalam pembelajaran, anak akan mencoba sendiri dalam membuat permainan, website dan program",
    button: "Mulai 🚀",
    gift: 30
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Berapa lama waktu yang dihabiskan anak dalam menggunakan gadget / komputer?",
      answers: [
        "Kurang lebih 2 jam",
        "Dari 2 hingga 4 jam",
        "Lebih dari 4 jam",
        "Saya kurang memperhatikan",
      ],
    },
    2: {
      question: "Perangkat apa yang lebih sering digunakan anak?",
      answers: [
        "Komputer",
        "Handphone / tablet",
        "Konsol",
        "Tidak tahu",
        "Anak tidak menggunakan perangkat apapun",
      ],
    },
    3: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
  },
};

